export default {
  state: {
    isMenuState: true,
    tableLoading: true,
    modifyLoading: {
      paramLoading: true,
      pdfLoading: true,
    },
    loadingState: '',
    path: '',//保证首页路径的序号
    temPath: '',//点击其他父节点时面包屑暂时不变
    isParamState: true,
    firstOutLoading: true,
    dirName: '',
    isReRunAnalyze: true,//是否重跑，为false时即需要重跑，但没有选择重，true为不需要重跑或者选择了重跑
  },
  mutations: {
    changeMenu(state) {
      state.isMenuState = !state.isMenuState
    },
    changeParamState(state) {
      state.isParamState = !state.isParamState
    },
    setTableLoading(state) {
      state.tableLoading = false
    },
    setPath(state, value) {
      state.path = value
    },
    setTemPath(state, value) {
      state.temPath = value
    },
    setName(state, value) {
      state.dirName = value
    },
    setFirstOutLoading(state) {
      state.firstOutLoading = false
    },
    setModifyLoading(state, value) {
      if (value === 'noPdf') {
        state.modifyLoading.paramLoading = false
        state.modifyLoading.pdfLoading = false
      } else if (value === 'param') {
        state.modifyLoading.paramLoading = false
      } else {
        state.modifyLoading.pdfLoading = false
      }
    },
    setDefaults(state) {
      state.tableLoading = true
      state.modifyLoading.pdfLoading = true
      state.modifyLoading.paramLoading = true
    },
    changeIsReRunAnalyze(state,value){
      state.isReRunAnalyze=value
    }
  },
  getters: {},
}
